// /* eslint-disable */
// import React, { useRef, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import { FaUserCircle, FaBars, FaHome } from 'react-icons/fa';
// import { BsFillCaretDownFill } from 'react-icons/bs';
// import logimg from '../../assets/images/logo_dashboard.png';
// import gdcnewlogo from '../../assets/images/gdcImages/tmgsl_xcelion-logo-rgb-Edited_updated.png';
// import styles from './Header.module.css';
// import config from '../../config/config';
// import UserProfile from '../UserProfile/UserProfile';
// import { IconButton } from '../../atomicComponents';


// const Header = ({ isRotate, notRotate, PageName, isClose }) => {
//   const [showProfile, setShowProfile] = useState(false);
//   const profileRef = useRef(null);
//   const history = useHistory();

//   const handleIconClick = () => {
//     notRotate(!isRotate);
//     isClose(prev => !prev);
//   };

//   return (
//     <div className={styles.header}>
//       <div className={styles.leftContainer}>
//         <FaBars
//           className={`${styles.toggleIcon} ${isRotate ? styles.rotate : ''}`}
//           onClick={handleIconClick}
//         />
//         <img className={styles.logo_xeclione} src={gdcnewlogo} alt="Tata Motors" />
//       </div>

//       <div className={styles.pageNameStyle}><h3>{PageName}</h3></div>

//       <div className={styles.rightContainer}>
//         <div className={styles.topIcons}>
//           <IconButton
//             className={styles.iconButton}
//             onClick={() => history.push('/')}
//           >
//             <FaHome style={{ fontSize: "15px" }} />
//           </IconButton>
//           <FaUserCircle />
//           <IconButton
//             className={styles.iconButton}
//             ref={profileRef}
//             onClick={() => setShowProfile(true)}
//           >
//             <BsFillCaretDownFill />
//           </IconButton>
//         </div>
//         <div className={styles.esakhaContainer}>
//           <a href={config.HOME_UI_BASE_URL} className={styles.homeLink}>
//             <img src={logimg} className={styles.logo} alt="IMPS 4.0" />
//           </a>
//         </div>
//       </div>

//       <UserProfile
//         open={showProfile}
//         anchorEl={profileRef.current}
//         handleClose={() => setShowProfile(false)}
//       />
//     </div>
//   );
// };

// export default Header;

// #######################################################################
/* eslint-disable */
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FaUserCircle, FaBars, FaHome } from 'react-icons/fa';
import { BsFillCaretDownFill } from 'react-icons/bs';
import logimg from '../../assets/images/logo_dashboard.png';
// import gdcnewlogo from '../../assets/images/gdcImages/tmgsl_xcelion-logo-rgb-Edited_updated.png';
import gdcnewlogo from '../../assets/images/gdcImages/tmgsl_xcelion-logo-rgb-Edited_updated.png';
import styles from './Header.module.css';
import config from '../../config/config';
import UserProfile from '../UserProfile/UserProfile';
import { IconButton } from '../../atomicComponents';
import { useSelector } from "react-redux";

// eslint-disable-next-line react/prop-types
const Header = ({ isRotate, notRotate, PageName, isClose }) => {
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const history = useHistory();

  const pgname = useSelector((state) => state.pagename.pagename);

  const handleIconClick = () => {
    notRotate(!isRotate);
    isClose(prev => !prev);
  };

  return (
    <div className={styles.header}>
      <div className={styles.leftContainer}>
        <FaBars
          className={`${styles.toggleIcon} ${isRotate ? styles.rotate : ''}`}
          onClick={handleIconClick}
        />
        <img className={styles.logo_xeclione} src={gdcnewlogo} alt="Tata Motors" />
      </div>
       <div className={styles.pageNameStyle}><h3>{pgname}</h3></div>
      <div className={styles.rightContainer}>
        <div className={styles.topIcons}>
          <IconButton
            className={styles.iconButton}
            onClick={() => history.push('/')}
          >
            <FaHome size={28} />
          </IconButton>
          <FaUserCircle />
          <IconButton
            className={styles.iconButton}
            ref={profileRef}
            onClick={() => setShowProfile(true)}
          >
            <BsFillCaretDownFill />
          </IconButton>
        </div>
        <div className={styles.esakhaContainer}>
          <a href={config.HOME_UI_BASE_URL} className={styles.homeLink}>
            <img src={logimg} className={styles.logo} alt="IMPS 4.0" />
          </a>
        </div>
      </div>
      <UserProfile
        open={showProfile}
        anchorEl={profileRef.current}
        handleClose={() => setShowProfile(false)}
      />
    </div>
  );
};

export default Header;